var _rect, _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 43.5,
    height: 43.5,
    rx: 3.75,
    fill: "white",
    stroke: "#E2E2E2",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5974 28.0744C29.9136 27.4975 29.3641 26.7781 28.9874 25.9666C28.6107 25.1551 28.4159 24.2711 28.4167 23.3765V20.8208C28.4167 17.5951 26.0205 14.9248 22.9167 14.4775V13.4875C22.9167 13.2444 22.8201 13.0112 22.6482 12.8393C22.4763 12.6674 22.2431 12.5708 22 12.5708C21.7569 12.5708 21.5237 12.6674 21.3518 12.8393C21.1799 13.0112 21.0833 13.2444 21.0833 13.4875V14.4775C17.9786 14.9248 15.5833 17.5951 15.5833 20.8208V23.3765C15.5837 24.2729 15.3879 25.1586 15.0098 25.9715C14.6316 26.7843 14.0803 27.5045 13.3943 28.0817C13.1464 28.2954 12.9697 28.5798 12.8879 28.8967C12.8061 29.2136 12.823 29.5479 12.9365 29.8549C13.05 30.1619 13.2545 30.4269 13.5228 30.6144C13.791 30.8019 14.1102 30.903 14.4375 30.9041H29.5625C30.4471 30.9041 31.1667 30.1846 31.1667 29.3C31.1667 28.8306 30.9622 28.387 30.5974 28.0744ZM22 34.5708C22.792 34.5697 23.5594 34.2956 24.1729 33.7947C24.7864 33.2937 25.2084 32.5966 25.3678 31.8208H18.6322C18.7916 32.5966 19.2136 33.2937 19.8271 33.7947C20.4405 34.2956 21.208 34.5697 22 34.5708Z",
    fill: "#313131"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2856,
    cy: 14.142,
    r: 4.71429,
    fill: "#FF5151"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 12.5708)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.6b8bbbd80c1d4060f43748ba8a0e300e.svg";
export { ForwardRef as ReactComponent };